module.exports = __webpack_public_path__ + "img/left-leg_active.66beb930.png";